import { Directive, ElementRef, inject } from '@angular/core';
import { fromEvent, Observable, Subject } from 'rxjs';

@Directive({
  selector: '[appInlineConfirmationCancel]',
  standalone: true,
  host: {
    "class": "inline-confirmation__operator"
  }
})
export class InlineConfirmationCancelDirective {
  private readonly _host: ElementRef<HTMLElement> | null = inject(ElementRef<HTMLElement>, { optional: true });

  private readonly _cancel$: Subject<PointerEvent> = new Subject<PointerEvent>();

  public readonly cancel$: Observable<PointerEvent> = this._cancel$.asObservable();

  constructor () {
    if (this._host?.nativeElement) {
      fromEvent<PointerEvent>(this._host.nativeElement, "click")
        .subscribe((pointerEvent: PointerEvent) => this._cancel$.next(pointerEvent));
    }
  }
}
